export const getFindOutMoreLink = (locale: string) => {
  switch (locale) {
    case 'de': {
      return 'https://www.doctify.com/de/about/business-center/arztinnen-zahnarztinnen-gesundheits-spezialisten'
    }
    case 'de-at': {
      return 'https://www.doctify.com/de-at/about/business-center/arztinnen-zahnarztinnen-gesundheits-profis/'
    }
    case 'au': {
      return 'https://www.doctify.com/au/about/join-doctify/professionals/'
    }
    case 'en-ae': {
      return 'https://www.doctify.com/en-ae/about/join-doctify/professionals/'
    }

    default:
      return 'https://www.doctify.com/uk/provider/join-doctify/professionals/'
  }
}

export const PASSWORD_MIN_LENGTH = 8

export const QUALITY_LIST = [
  {
    title: 'CYP.first-quality-block.title',
    description: 'CYP.first-quality-block.description',
    imageProps: { src: '/hermes-static/icons/qualityList1.svg', alt: '' },
    bgColor: 'primary.dark',
    isTextWhite: true,
    buttonColor: 'primary.main'
  },
  {
    title: 'CYP.second-quality-block.title',
    description: 'CYP.second-quality-block.description',
    imageProps: { src: '/hermes-static/icons/qualityList2.svg', alt: '' },
    bgColor: 'system.coral200'
  },
  {
    title: 'CYP.third-quality-block.title',
    description: 'CYP.third-quality-block.description',
    imageProps: { src: '/hermes-static/icons/qualityList3.svg', alt: '' },
    bgColor: 'rgba(0, 229, 208, 0.1)'
  },
  {
    title: 'CYP.fourth-quality-block.title',
    description: 'CYP.fourth-quality-block.description',
    imageProps: { src: '/hermes-static/icons/qualityList4.svg', alt: '' },
    bgColor: 'blue.200',
    buttonColor: 'primary.main'
  }
]

export const getFormFieldData = (translate: (key: string) => string) => [
  {
    name: 'email',
    placeholder: translate('CYP.email'),
    regExp: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    errorMessage: translate('error.invalidEmail'),
    type: 'email'
  },
  {
    name: 'password',
    placeholder: translate('set_password'),
    regExp: /^(?=.*[A-Z])(?=.*[\W_]).*$/,
    errorMessage: translate('error.invalid-password'),
    type: 'password'
  },
  {
    name: 'confirmPassword',
    placeholder: translate('confirm_password'),
    regExp: /^(?=.*[A-Z])(?=.*[\W_]).*$/,
    errorMessage: translate('error.invalid-password'),
    type: 'password'
  }
]

export const CLAIM_YOUR_PROFILE_ROUTES = {
  BASE: '/claim-your-profile',
  BASE_DE: '/beanspruchen-sie-ihr-profil',
  CONNECT: '/claim-your-profile-connect',
  CONNECT_DE: '/beanspruchen-sie-ihr-profil-vernetzen',
  PROVIDER_WPA: '/claim-your-profile-wpa',
  PROVIDER_HCA: '/claim-your-profile-hca',

  get PROVIDERS() {
    return [this.PROVIDER_WPA, this.PROVIDER_HCA]
  },

  get ALL() {
    return [this.BASE, this.BASE_DE, this.CONNECT, this.CONNECT_DE, this.PROVIDER_WPA, this.PROVIDER_HCA]
  }
}
